import { render, staticRenderFns } from "./ErrorItem.vue?vue&type=template&id=51cde279&"
import script from "./ErrorItem.vue?vue&type=script&lang=js&"
export * from "./ErrorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports